import { createLoader } from './loader';

export default function initCasesFilters(root) {
  if (!root) return;
 const filtersList = document.querySelector('.cases__filters-list');
  const toggleBtn = document.querySelector('.cases__filters-toggle-btn');

  if (filtersList && toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      toggleBtn.classList.toggle('opened');
      filtersList.classList.toggle('opened');
    });
  }

  const ajaxurl    = root.dataset.ajaxurl || '';
  const nonce      = root.dataset.nonce || '';
  const perPageCfg = parseInt(root.dataset.perPage || '9', 10) || 9;
  const lottiePath = root.dataset.lottie || '';

  const resultsBox      = root.querySelector('#casesResults');
  const $uc             = root.querySelector('#filterSelect0');
  const $sv             = root.querySelector('#filterSelect1');
  const $ind            = root.querySelector('#filterSelect2');
  const $ct             = root.querySelector('#filterSelect3');
  const $videoOnly      = root.querySelector('#casesVideoOnly');
  const $showMore       = root.querySelector('.cases__show-more-btn');
  const $pagination     = root.querySelector('.cases__pagination');
  const $paginationWrap = root.querySelector('.cases__pagination-wrapper');

  // Mount on root so the loader is not removed when resultsBox.innerHTML changes
  const loader = createLoader(root, {
    path: lottiePath,
    mount: root,
    debug: true
  });

  const getMany   = (el) => el ? Array.from(el.selectedOptions || []).map(o => o.value).filter(Boolean) : [];
  const getSingle = (el) => (el && el.value && el.value !== '' ? el.value : '');

  function getFilters() {
    const useCases   = $uc  ? ($uc.multiple  ? getMany($uc)  : (getSingle($uc)  ? [getSingle($uc)]  : [])) : [];
    const services   = $sv  ? ($sv.multiple  ? getMany($sv)  : (getSingle($sv)  ? [getSingle($sv)]  : [])) : [];
    const industries = $ind ? ($ind.multiple ? getMany($ind) : (getSingle($ind) ? [getSingle($ind)] : [])) : [];
    const countries  = $ct  ? ($ct.multiple  ? getMany($ct)  : (getSingle($ct)  ? [getSingle($ct)]  : [])) : [];

    const payload = {
      use_cases:  useCases.map(v => parseInt(v, 10)).filter(Number.isFinite),
      services:   services.map(v => parseInt(v, 10)).filter(Number.isFinite),
      industries: industries.map(v => parseInt(v, 10)).filter(Number.isFinite),
      countries:  countries.map(v => String(v).toLowerCase()),
      video_only: !!($videoOnly && $videoOnly.checked),
    };
    return payload;
  }

  let currentPage = 1;
  let lastKey   = '';
  let scheduled = false;
  let inFlight  = false;
  const PER_PAGE = perPageCfg;

  function scheduleFetch() {
    currentPage = 1;
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => { scheduled = false; fetchAndRender(currentPage, 'replace'); }, 120);
  }

  async function fetchAndRender(page = 1, mode = 'replace') {
    const state = { ...getFilters(), page, per_page: PER_PAGE };
    const key   = JSON.stringify(state);
    if (key === lastKey || inFlight) {
      return;
    }
    lastKey = key; inFlight = true;
    loader.show();

    const form = new FormData();
    form.append('action',   'filter_cases');
    form.append('nonce',    nonce);
    form.append('page',     String(page));
    form.append('per_page', String(PER_PAGE));
    state.use_cases.forEach(v  => form.append('use_cases[]',  String(v)));
    state.services.forEach(v   => form.append('services[]',   String(v)));
    state.industries.forEach(v => form.append('industries[]', String(v)));
    state.countries.forEach(v  => form.append('countries[]',  v));
    form.append('video_only', state.video_only ? '1' : '0');

    root.querySelectorAll('.cases-filters').forEach(s => (s.disabled = true));
    if ($showMore) $showMore.disabled = true;

    try {
      const res = await fetch(ajaxurl, { method: 'POST', body: form, credentials: 'same-origin' });
      const data = await res.json();

      if (data?.success) {
        const { html, total, page: srvPage, has_more } = data.data || {};
        if (mode === 'append') {
          resultsBox.insertAdjacentHTML('beforeend', html || '');
        } else {
          resultsBox.innerHTML = html || '';
        }
        currentPage = srvPage || page;
        const totalPages = Math.max(1, Math.ceil((+total || 0) / PER_PAGE));
        updateShowMore(!!has_more);
        renderPagination(totalPages, currentPage);
        if ($paginationWrap) $paginationWrap.style.display = totalPages > 1 ? '' : 'none';
      } 
    } catch (e) {
      console.error('[Cases] fetch exception', e);
    } finally {
      loader.hide();

      root.querySelectorAll('.cases-filters').forEach(s => (s.disabled = false));
      if ($showMore) $showMore.disabled = false;
      inFlight = false;
    }
  }

  function updateShowMore(hasMore) {
    if (!$showMore) return;
    $showMore.style.display = hasMore ? '' : 'none';
  }

  if ($showMore) {
    $showMore.addEventListener('click', () => {
      if (inFlight) return;
      fetchAndRender(currentPage + 1, 'append');
    });
  }

  function renderPagination(totalPages, page) {
    if (!$pagination) return;
    if (totalPages <= 1) { $pagination.innerHTML = ''; return; }

    const pages = [];
    const add = p => { if (p >= 1 && p <= totalPages && !pages.includes(p)) pages.push(p); };
    add(1); add(totalPages);
    for (let p = page - 1; p <= page + 1; p++) add(p);
    pages.sort((a,b)=>a-b);

    let html = '';
    html += `<button type="button" class="btn--pagination" data-dir="prev" ${page===1?'disabled':''} aria-label="Previous page">‹</button>`;
    pages.forEach((p, i) => {
      if (i>0 && p - pages[i-1] > 1) html += `<span class="cases__pagination-ellipsis">…</span>`;
      html += `<button type="button" class="btn--pagination ${p===page?'active':''}" data-page="${p}">${p}</button>`;
    });
    html += `<button type="button" class="btn--pagination" data-dir="next" ${page===totalPages?'disabled':''} aria-label="Next page">›</button>`;
    $pagination.innerHTML = html;
  }

  if ($pagination) {
    $pagination.addEventListener('click', (e) => {
      const btn = e.target.closest('button.btn--pagination');
      if (!btn || btn.disabled) return;

      if (btn.dataset.page) {
        const p = parseInt(btn.dataset.page, 10);
        if (Number.isFinite(p) && p !== currentPage) fetchAndRender(p, 'replace');
        return;
      }
      if (btn.dataset.dir === 'prev' && currentPage > 1) {
        fetchAndRender(currentPage - 1, 'replace'); return;
      }
      if (btn.dataset.dir === 'next') {
        fetchAndRender(currentPage + 1, 'replace'); return;
      }
    });
  }

  root.addEventListener('cases:filters:changed', (e) => {
    if (e.target?.classList?.contains('cases-filters')) scheduleFetch();
  });
  root.addEventListener('change', (e) => {
    if (e.target?.classList?.contains('cases-filters')) scheduleFetch();
  });
  if ($videoOnly) $videoOnly.addEventListener('change', scheduleFetch);
}